import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { orderFormElement, OrderFormElementAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useOrderFormElement(): LocalOperation<
	(payload: ActionPayload<OrderFormElementAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<OrderFormElementAction>) {
		dispatch(orderFormElement(payload));
	}

	return handler;
}
